module.exports = __webpack_public_path__ + "25270e5c5ad6472e33892c278506c695.svg";